export const CONTECT_SHOW = 'CONTECT_SHOW'
export const CONTECT_HIDE = 'CONTECT_HIDE'
